/* tslint:disable */
/* eslint-disable */

/**
 * 805290000 = Zahlung (Zahlung)
 * 
 * 805290001 = Ruckzahlung (Rückzahlung)
 */
import {EnumValue} from "@/core/models/enumvalue.model"
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export enum GlobalEnumsAceTyp {
 Zahlung = 805290000,
 Ruckzahlung = 805290001
}

marker([
    "Enum.GlobalEnumsAceTyp.Zahlung",
    "Enum.GlobalEnumsAceTyp.Ruckzahlung"
]);

export namespace GlobalEnumsAceTyp
{
    class DataSets
    {
        static GlobalEnumsAceTypDataSet: Array<EnumValue> = new Array<EnumValue>(
            new EnumValue("Zahlung", 805290000, "Zahlung"),
            new EnumValue("Ruckzahlung", 805290001, "Rückzahlung"),
        )
    }

    export function getAsDataset() {
        return DataSets.GlobalEnumsAceTypDataSet;
    }
}
